import { Splitter, SplitterOnChangeEvent, SplitterPaneProps } from "@progress/kendo-react-layout";
import { useEffect, useState } from "react";
import { Agence } from "../models/Agence";
import { Magasin } from "../models/Magasin";
import { useGetAgencesQuery } from "../redux/api/cache";
import Header from "./Header";
import DeliveryGrid from "./delivery/DeliveryGrid";
import EmployeesList from "./employees/EmployeesList";
import { getDateWithoutTime } from "../commons/helpers/Dates";

export default function MainLayout() {
    const [magasin, setMagasin] = useState<Magasin>({ mag_nom: "", mag_nom_aff: "", mag_num: -1 });
    const [date, setDate] = useState<Date>(getDateWithoutTime(new Date()));
    const [panes, setPanes] = useState<SplitterPaneProps[]>([
        { collapsible: false },
        { size: '20%', min: '20px', collapsible: false }
    ]);
    const [itemInEdit, setItemInEdit] = useState<boolean>(false);
    const [agence, setAgence] = useState<Agence>({ agence_cd: "", agence_nom: "" });
    const { data: agences = [] } = useGetAgencesQuery();

    useEffect(() => {
        if (agences.length === 1)
            setAgence(agences[0]);
    }, [agences])

    return <div className="k-flex-grow k-h-full k-max-h-full k-min-h-0">
        {agences.length === 0 && (<h2>Vos droits actuels ne vous permettent pas l'accès à une agence.</h2>)}
        {agences.length !== 0 && (<Splitter className="h-100" orientation="horizontal" panes={panes} onChange={(event: SplitterOnChangeEvent) => setPanes(event.newState)}>
            <div className="k-d-flex k-flex-column k-min-h-full k-max-h-full p-2">
                <Header date={date} setDate={setDate} magasin={magasin} setMagasin={setMagasin} itemInEdit={itemInEdit} agences={agences} agence={agence} setAgence={setAgence} />
                <hr className="k-flex-grow-0" />
                <DeliveryGrid date={date} magasin={magasin} itemInEdit={itemInEdit} setItemInEdit={setItemInEdit} agence={agence} panes={panes} />
            </div>
            <div className="k-d-flex k-flex-column k-min-h-full k-max-h-full p-2">
                <h4 className="k-flex-grow-0">Employés</h4>
                <EmployeesList date={date} magasin={magasin} agence={agence} />
            </div>
        </Splitter>)}
    </div>;
}
